"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAYER_INJURY = exports.PLAYER_CARAC = exports.CARAC_MIN = exports.CARAC_MAX = exports.AGING_SIZE_RANGE = exports.AGING_MIN_BONUS = exports.AGING_INITIAL_BONUS = void 0;
exports.areFromSameTeam = areFromSameTeam;
exports.arePlayingSameGame = arePlayingSameGame;
exports.BB2020Carac = BB2020Carac;
exports.gamesforAgingRoll = gamesforAgingRoll;
exports.getAgingBonus = getAgingBonus;
exports.getCareerBaseCarac = getCareerBaseCarac;
exports.getCareerBaseCaracLimit = getCareerBaseCaracLimit;
exports.getMaxAG = getMaxAG;
exports.getMaxAV = getMaxAV;
exports.getMaxCarac = getMaxCarac;
exports.getMaxCommun = getMaxCommun;
exports.getMaxGfi = getMaxGfi;
exports.getMaxMA = getMaxMA;
exports.getMaxPA = getMaxPA;
exports.getMaxST = getMaxST;
exports.hasMove = hasMove;
exports.hasTeam = hasTeam;
exports.isPlaying = isPlaying;
exports.isPlayingGame = isPlayingGame;
exports.isRookie = isRookie;
exports.isTeam1 = isTeam1;
exports.isTeamPlaying = isTeamPlaying;
exports.isTeamPlayingGame = isTeamPlayingGame;
const career_1 = require("./career");
const improvement_1 = require("./improvement");
const meteo_1 = require("./meteo");
const race_1 = require("./race");
const skill_1 = require("./skill");
var PLAYER_INJURY;
(function (PLAYER_INJURY) {
    PLAYER_INJURY["BADLY_HURT"] = "badly-hurt";
    PLAYER_INJURY["SERIOUSLY_HURT"] = "seriously-hurt";
    PLAYER_INJURY["SERIOUS"] = "serious";
    PLAYER_INJURY["LASTING"] = "lasting";
    PLAYER_INJURY["DEAD"] = "dead";
})(PLAYER_INJURY || (exports.PLAYER_INJURY = PLAYER_INJURY = {}));
var PLAYER_CARAC;
(function (PLAYER_CARAC) {
    PLAYER_CARAC["AG"] = "AG";
    PLAYER_CARAC["AV"] = "AV";
    PLAYER_CARAC["MA"] = "MA";
    PLAYER_CARAC["ST"] = "ST";
    PLAYER_CARAC["PA"] = "PA";
})(PLAYER_CARAC || (exports.PLAYER_CARAC = PLAYER_CARAC = {}));
// Valeurs maximales absolues des caractéristiques (rulebook 2020)
const CARAC_MAX = {
    [PLAYER_CARAC.MA]: 9,
    [PLAYER_CARAC.ST]: 8,
    [PLAYER_CARAC.AG]: 5, // interne 5 = affichage 1+
    [PLAYER_CARAC.PA]: 5, // interne 5 = affichage 1+
    [PLAYER_CARAC.AV]: 10, // interne 10 = affichage 11+
};
exports.CARAC_MAX = CARAC_MAX;
// Valeurs minimales absolues des caractéristiques
const CARAC_MIN = {
    [PLAYER_CARAC.MA]: 1,
    [PLAYER_CARAC.ST]: 1,
    [PLAYER_CARAC.AG]: 1, // interne 1 = affichage 6+
    [PLAYER_CARAC.PA]: 1, // interne 1 = affichage 6+
    [PLAYER_CARAC.AV]: 2, // interne 2 = affichage 3+
};
exports.CARAC_MIN = CARAC_MIN;
function hasMove(player, game) {
    if (player.current_MA >= getMaxCarac(player, PLAYER_CARAC.MA, game) &&
        player.current_gfi >= getMaxGfi(player) &&
        !(0, skill_1.hasUsedSkill)(player, skill_1.SKILL_NAMES.JUMP_UP)) {
        return false;
    }
    return true;
}
function arePlayingSameGame(p1, p2) {
    return p1.gameId == p2.gameId;
}
function hasTeam(player) {
    return player.teamId != null;
}
function areFromSameTeam(p1, p2) {
    return p1.teamId == p2.teamId;
}
function isPlaying(player) {
    return player.gameId != null;
}
function isPlayingGame(player, game) {
    return player.gameId == game.id;
}
function isTeamPlaying(team) {
    return team.game_id != null;
}
function isTeamPlayingGame(team, game) {
    return team.game_id == game.id;
}
function isTeam1(player, game) {
    return player.teamId == game.team1_id;
}
function isRookie(player) {
    const date = new Date(player.userCreatedAt);
    const fourMonthsAgo = new Date();
    fourMonthsAgo.setMonth(fourMonthsAgo.getMonth() - 3);
    return +fourMonthsAgo < +date;
}
function getCareerBaseCarac(player, carac) {
    const career = (0, race_1.getCareerFromPlayer)(player);
    if (!career) {
        throw new Error("No career for player " + player.id + ": " + player.race_id);
    }
    return career[carac];
}
function getCareerBaseCaracLimit(player, value, carac) {
    const base = getCareerBaseCarac(player, carac);
    if (value > base + 2) {
        value = base + 2;
    }
    if (value < base - 2) {
        value = base - 2;
    }
    return value;
}
function getMaxCarac(player, carac, game) {
    if (!player) {
        return -1;
    }
    if (carac === PLAYER_CARAC.AG) {
        return getMaxAG(player, game || {});
    }
    else if (carac === PLAYER_CARAC.MA) {
        return getMaxMA(player, game || {});
    }
    else if (carac === PLAYER_CARAC.AV) {
        return getMaxAV(player, game || {});
    }
    else if (carac === PLAYER_CARAC.ST) {
        return getMaxST(player, game || {});
    }
    else if (carac === PLAYER_CARAC.PA) {
        return getMaxPA(player, game);
    }
    return -1;
}
function getMaxCommun(player, carac, _game) {
    let c = player[carac];
    if (c == null) {
        return 0;
    }
    if (!player.tempCarac) {
        return c;
    }
    let obj;
    try {
        obj = JSON.parse(player.tempCarac);
    }
    catch (e) {
        return c;
    }
    for (const value of Object.values(obj)) {
        // TODO : Check if this is correct
        if (value.gainCarac === PLAYER_CARAC[carac]) {
            c += 1;
        }
        if (value.loseCarac === PLAYER_CARAC[carac]) {
            c -= 1;
        }
    }
    c = getCareerBaseCaracLimit(player, c, PLAYER_CARAC[carac]);
    return c;
}
function getMaxAV(player, game) {
    let c = getMaxCommun(player, PLAYER_CARAC.AV, game);
    if (c > CARAC_MAX[PLAYER_CARAC.AV])
        c = CARAC_MAX[PLAYER_CARAC.AV];
    if (c < CARAC_MIN[PLAYER_CARAC.AV])
        c = CARAC_MIN[PLAYER_CARAC.AV];
    return c;
}
function getMaxST(player, game) {
    let c = getMaxCommun(player, PLAYER_CARAC.ST, game);
    if (c > CARAC_MAX[PLAYER_CARAC.ST])
        c = CARAC_MAX[PLAYER_CARAC.ST];
    if (c < CARAC_MIN[PLAYER_CARAC.ST])
        c = CARAC_MIN[PLAYER_CARAC.ST];
    return c;
}
function getMaxAG(player, game) {
    let c = getMaxCommun(player, PLAYER_CARAC.AG, game);
    if (c > CARAC_MAX[PLAYER_CARAC.AG])
        c = CARAC_MAX[PLAYER_CARAC.AG];
    if (c < CARAC_MIN[PLAYER_CARAC.AG])
        c = CARAC_MIN[PLAYER_CARAC.AG];
    return c;
}
function getMaxMA(player, game) {
    let c = getMaxCommun(player, PLAYER_CARAC.MA, game);
    if (game) {
        const maxMA = (0, meteo_1.meteoMaxMA)(game.meteo);
        if (c > maxMA) {
            c = maxMA;
        }
    }
    if (c > CARAC_MAX[PLAYER_CARAC.MA])
        c = CARAC_MAX[PLAYER_CARAC.MA];
    if (c < CARAC_MIN[PLAYER_CARAC.MA])
        c = CARAC_MIN[PLAYER_CARAC.MA];
    return c;
}
function clampPA(c) {
    if (c < CARAC_MIN[PLAYER_CARAC.PA])
        return CARAC_MIN[PLAYER_CARAC.PA];
    if (c > CARAC_MAX[PLAYER_CARAC.PA])
        return CARAC_MAX[PLAYER_CARAC.PA];
    return c;
}
function getMaxPA(player, game) {
    // Si le joueur a déjà une valeur PA en base, l'utiliser
    if (player.PA != null) {
        let c = getMaxCommun(player, PLAYER_CARAC.PA, game || {});
        return clampPA(c);
    }
    // Sinon, déterminer la valeur selon la version de la career
    const career = (0, race_1.getCareerFromPlayer)(player);
    if (!career) {
        // Fallback: utiliser AG si pas de career
        return getMaxAG(player, game || {});
    }
    // Si c'est une career 2025, utiliser career.PA
    if (career.version === career_1.CAREER_VERSION.V2025 && career.PA != null) {
        let c = career.PA;
        // Appliquer les modificateurs tempCarac si présents
        if (player.tempCarac) {
            let obj;
            try {
                obj = JSON.parse(player.tempCarac);
            }
            catch (e) {
                return clampPA(c);
            }
            for (const value of Object.values(obj)) {
                if (value.gainCarac === PLAYER_CARAC.PA) {
                    c += 1;
                }
                if (value.loseCarac === PLAYER_CARAC.PA) {
                    c -= 1;
                }
            }
            c = getCareerBaseCaracLimit(player, c, PLAYER_CARAC.PA);
        }
        return clampPA(c);
    }
    // Sinon (career 2020 ou V6), utiliser AG
    return getMaxAG(player, game || {});
}
function getMaxGfi(player) {
    return (0, skill_1.hasSkill)(player, skill_1.SKILL_NAMES.SPRINT) ? 3 : 2;
}
const AGING_SIZE_RANGE = 5;
exports.AGING_SIZE_RANGE = AGING_SIZE_RANGE;
function gamesforAgingRoll(totalGames) {
    if (totalGames <= 0) {
        return AGING_SIZE_RANGE;
    }
    if (totalGames % AGING_SIZE_RANGE === 0) {
        return 0;
    }
    return AGING_SIZE_RANGE - (totalGames % AGING_SIZE_RANGE);
}
const AGING_INITIAL_BONUS = 5;
exports.AGING_INITIAL_BONUS = AGING_INITIAL_BONUS;
const AGING_MIN_BONUS = -3;
exports.AGING_MIN_BONUS = AGING_MIN_BONUS;
function getAgingBonus(player, totalGames) {
    if (player.experience < (0, improvement_1.getAgingMinExperience)()) {
        return null;
    }
    if (gamesforAgingRoll(totalGames) !== 0) {
        return null;
    }
    const range = totalGames / AGING_SIZE_RANGE;
    // 5  = 1 = 4
    // 10 = 2 = 3
    // 15 = 3 = 2
    // 20 = 4 = 1
    // 25 = 5 = 0
    // 30 = 6 = -1
    // 35 = 7 = -2
    // 40 = 8 = -3
    let bonus = AGING_INITIAL_BONUS - range;
    if (bonus < AGING_MIN_BONUS) {
        bonus = AGING_MIN_BONUS;
    }
    return bonus;
}
function BB2020Carac(value, carac, careerVersion) {
    //   CHARACTERISTIC TABLE
    // Characteristic MA ST AG PA AV
    // Maximum 9 8 1+ 1+ 11+
    //Minimum 1 1 6+ 6+ 3+
    // Les valeurs sont maintenant normalisées au format 2020 pour toutes les versions
    // (les valeurs 2025 sont converties lors de la génération du fichier career2025.ts)
    if (carac === PLAYER_CARAC.AV && value) {
        // TODO: min3+, max11+
        return `${+value + 1}+`;
    }
    else if ((carac === PLAYER_CARAC.AG || carac === PLAYER_CARAC.PA) &&
        value) {
        // Conversion pour afficher la notation "+"
        // PA se comporte exactement comme AG (PA n'existait pas en 2020)
        // Valeur interne -1 = "6+" (passe très difficile, distinct de 0 = pas de passe)
        if (value === -1)
            return "6+";
        let newValue = 6;
        if (value <= 1)
            newValue = 6;
        if (value === 2)
            newValue = 5;
        else if (value === 3)
            newValue = 4;
        else if (value === 4)
            newValue = 3;
        else if (value === 5)
            newValue = 2;
        else if (value >= 6)
            newValue = 1;
        newValue -= 1;
        if (newValue <= 1)
            newValue = 1;
        if (newValue >= 6)
            newValue = 6;
        return `${newValue}+`;
    }
    return value;
}
